import BaseObject from '../../../base/base_object';
import DateFormatter from '../../../utils/date_formatter';
import ServiceFactory from '../../service_factory';
import IRestrictionMessages from './restriction_messages_interface';
import {DialogButtonClickHandleResultEnum} from "../../../../../app-react/services/dialog/dialog.service.interface";


const DEFAULT_DATETIME_FORMATTING = 'dd.mm.yyyy H:MM';

export default class RestrictionMessages extends BaseObject implements IRestrictionMessages{
    static CLASS = 'GenericRestrictionMessage';
    private _serviceFactory: ServiceFactory;

    init(params) {
        super.init(params);
        this._serviceFactory = params.serviceFactory;
    }

    public showGenericMessage(): void {
        const translation = this._serviceFactory.translationProxyService();

        this._serviceFactory.dialogProxyService().showSimpleTextModal({
            text: translation.translate('100200'),
            title: '',
            showEmptyTitle: true,
            buttons: [
                {
                    text: translation.translate('OK'),
                    buttonPreset: 'primary',
                    onClick: async () => {
                        this._serviceFactory.analyticsService().sendOrbitUserFlowEvent({
                            category: 'Client_RestrictionError',
                            action: 'CTA_1',
                            label: 'OK'
                        });

                        return DialogButtonClickHandleResultEnum.CloseDialogAndContinue;
                    }
                }
            ]
        })
    }

    public showSessionLimitMessage(expirationDate: any): void {
        const translation = this._serviceFactory.translationProxyService();

        this._serviceFactory.dialogProxyService().showSimpleTextModal({
            title: translation.translate('GENERIC_NOTIFICATION_POPUP_TITLE'),
            text: translation.translate('GAMBLING_SESSION_SELF_RESTRICTION_MESSAGE', {
                restrictionExpirationDate: this._formatDate(expirationDate)
            }),
            buttons: [
                {
                    text: translation.translate('OK'),
                    buttonPreset: 'primary',
                    onClick: async () => {
                        this._serviceFactory.analyticsService().sendOrbitUserFlowEvent({
                            category: 'Client_SelfRestrictionError',
                            action: 'CTA_1',
                            label: 'OK'
                        });

                        return DialogButtonClickHandleResultEnum.CloseDialogAndContinue;
                    }
                }
            ]
        })
    }

    private _formatDate(date: any) {
        return  DateFormatter.format(date, this._serviceFactory.skinService().getDateTimeFormat() || DEFAULT_DATETIME_FORMATTING);
    }
}